<template>
  <div class="os" @click.self="toHome" v-show="isShowOs">
    <div class="os-wrapper animated">
      <div class="login-bg">
        <div v-if="allInfo && Object.keys(allInfo).length > 1">
          <tab-bar
            :titles="titles"
            @titleClick="titleClick"
            className="os-tab-bar"
          ></tab-bar>
        </div>

        <div class="option-box">
          <div
            class="input sm-input"
            v-show="selectionShow && gameName !== 'snail'"
          >
            <select
              class="fl"
              v-model="productOs"
              @focus="inputFocus()"
              @focusout="inputFocusOut"
              @change="roleId = ''"
            >
              <option value="">请选择设备</option>
              <option
                value="ios"
                v-if="
                  !['servitor', 'hjwq', 'hjwq2', 'sakura', 'travel'].includes(
                    gameName
                  )
                "
              >
                ios
              </option>
              <option
                value="android"
                v-if="
                  !['servitor', 'hjwq', 'hjwq2', 'sakura', 'travel'].includes(
                    gameName
                  )
                "
              >
                android
              </option>
              <option value="android" v-else>ios/安卓</option>
            </select>
          </div>
          <div class="input">
            <select
              v-model="roleId"
              @focus="inputFocus()"
              @focusout="inputFocusOut"
            >
              <option value="">请选择区组</option>
              <option
                v-for="(item, index) in allUserInfo"
                :key="index"
                :value="item.role_id"
              >
                <span v-if="gameName === 'snail'">
                  {{
                    "区服:" + item.server_name + " 综合实力:" + item.extra.score
                  }}
                </span>
                <span v-else>
                  {{ item.server_name }}
                  {{ gameName === "sakura" ? "" : item.server_id + "服"
                  }}{{
                    item.raw_server_id
                      ? "(原：" + item.raw_server_name + "服)"
                      : ""
                  }}
                </span>
              </option>
            </select>
          </div>
          <div class="input input-name">
            <input
              type="text"
              name=""
              value=""
              readonly
              v-model="roleName"
              placeholder="请选择角色"
              @focus="inputFocus()"
              @focusout="inputFocusOut"
            />
          </div>
        </div>
        <div class="btn-box">
          <div class="cancell-btn" @click="cancell">注销</div>
          <div class="confirm-btn" @click="ok">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TabBar from "../../../../components/TabBar";
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations } from "vuex";
import { LogoutAPI } from "@/api/login";
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { GetRoleList, BindRoleAPI } from "@/api/os";
import _ from "lodash";
export default {
  name: "Os",
  components: { TabBar },
  data() {
    return {
      areaConfig: [],
      titles: [],
      selectionShow: 0,
      productOs: "",
      roleId: "",
      allInfo: {},
      isHasRole: true,
    };
  },
  props: {
    gameName: {
      type: String, // 传入参数：snail | tideng | timeTravel | servitor | hjwq
      default: "",
    },
  },
  created() {
    this.areaConfig = GAME_AREA[this.gameName];
    this.titles = this.areaConfig.map((item) => item.name);
    this.isHasRole = false;
    GetRoleList({
      account: this.userInfo.account,
      page_id: PAGE_ID[this.gameName],
      app_id: APP_ID[this.gameName],
    })
      .then((response) => {
        if (Number(response.code) === 200) {
          let data = response.data;
          // 存该用户所有的账号信息
          this.allInfo = data;
          // 判断是否显示选择设备
          // if (this.gameName === 'snail') {
          //   this.selectionShow = 0
          // } else {
          this.selectionShow = data[this.areaConfig[0].id] ? 0 : 1;
          // }
          this.isHasRole = true;
        }
      })
      .catch((response) => {
        if (Number(response.code) === 401) {
          this.isHasRole = false;
          this.changeOsPopup(false);
          this.$emit("noRole");
        }
      });
  },
  methods: {
    // 渠道切换
    titleClick(index) {
      if (this.gameName === "snail") {
        this.selectionShow = index;
        this.productOs = "android";
      } else {
        this.selectionShow = index;
        this.productOs = "";
      }
      this.roleId = "";
    },
    toHome() {
      if (!this.userInfo.game_id) {
        this.setUserInfo({});
      }
      this.changeOsPopup(false);
    },
    // 注销
    cancell: _.throttle(
      function () {
        LogoutAPI({ game_id: this.userInfo.game_id }).then((response) => {
          if (Number(response.code) === 200) {
            this.logout();
          }
        });
      },
      1000,
      { trailing: false }
    ),
    ok: _.throttle(
      function () {
        if (this.productOs === "") {
          return Toast({
            message: "请选择设备",
            duration: 1000,
            className: "toasts",
          });
        }
        if (this.roleId === "") {
          return Toast({
            message: "请选择区组",
            duration: 1000,
            className: "toasts",
          });
        }
        if (
          this.roleName === "" ||
          this.roleId === "" ||
          this.productOs === ""
        ) {
          return;
        }
        let selectInfo = this.allUserInfo.find(
          (item) => item.role_id === this.roleId
        );
        selectInfo["game_id"] = this.selectionShow
          ? this.areaConfig[1].id
          : this.areaConfig[0].id;
        selectInfo.type = this.productOs;
        selectInfo.dist = APP_ID[this.gameName];
        selectInfo.extra = JSON.stringify(selectInfo.extra);
        Indicator.open();
        BindRoleAPI(selectInfo)
          .then((response) => {
            if (Number(response.code) === 200) {
              this.$emit("getSelectInfo", selectInfo, "");
              this.selectRole();
            }
          })
          .finally(() => Indicator.close());
      },
      1000,
      { trailing: false }
    ),
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    selectRole() {
      this.$emit("selectCallback");
      this.changeOsPopup(false);
    },
    changeProductOs(val) {
      this.productOs = val;
    },
    logout() {
      // 清空数据 控制弹窗
      window.localStorage.setItem("access_token", "");
      this.setInitUserInfo();
      this.setInitActiveInfo();
      this.changeOsPopup(false);
      this.changeLoginPopup(true);
      this.$emit("logoutCallback");
      this.$emit("getSelectInfo", {}, "");
    },
    ...mapMutations([
      "setUserInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setInitUserInfo",
      "setInitActiveInfo",
    ]),
  },

  computed: {
    allUserInfo() {
      // 当选中的是光子服时, 系统自动选为android
      if (this.selectionShow === 0) {
        this.changeProductOs("android");
      }
      let allUserInfo =
        this.allInfo && this.allInfo[this.channelIndex]
          ? this.allInfo[this.channelIndex][this.productOs]
          : [];
      return allUserInfo;
    },
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.roleId
        ? this.allUserInfo.find((item) => item.role_id === this.roleId)
            .role_name
        : "";
      return roleName;
    },
    channelIndex() {
      switch (this.selectionShow) {
        case 0:
          return this.areaConfig[0].id;
        case 1:
          return this.areaConfig[1].id;
        default:
          break;
      }
    },
    ...mapState(["userInfo", "isShowLogin", "isShowOs"]),
  },

  filters: {},
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/springFestival/os/index.vue